<div class="flex flex-col items-center justify-center min-h-[150px]">
  <p-progress-spinner ariaLabel="loading" />
  <h1>Redirecting... Please wait</h1>
</div>